// FETCH_POINTS_CASH_CONFIG

const initialState = { isLoading: false, paymentConfig: [], requestMake: false, finishRequests: false, isError: false };
export const FETCH_POINTS_CASH_CONFIG = 'FETCH_POINTS_CASH_CONFIG';
export const FETCH_POINTS_CASH_CONFIG_SUCCESS = `${FETCH_POINTS_CASH_CONFIG}_SUCCESS`;
export const FETCH_POINTS_CASH_CONFIG_FAIL = `${FETCH_POINTS_CASH_CONFIG}_FAIL`;

export const FETCH_POINTS_CASH_INSTALLMENTS = 'FETCH_POINTS_CASH_INSTALLMENTS';
export const FETCH_POINTS_CASH_INSTALLMENTS_SUCCESS = `${FETCH_POINTS_CASH_INSTALLMENTS}_SUCCESS`;
export const FETCH_POINTS_CASH_INSTALLMENTS_FAIL = `${FETCH_POINTS_CASH_INSTALLMENTS}_FAIL`;

export const FETCH_CREATE_PURCHASE = 'FETCH_CREATE_PURCHASE';
export const FETCH_RESET_PURCHASE = 'FETCH_RESET_PURCHASE';
export const FETCH_CREATE_PURCHASE_SUCCESS = `${FETCH_CREATE_PURCHASE}_SUCCESS`;
export const FETCH_CREATE_PURCHASE_FAIL = `${FETCH_CREATE_PURCHASE}_FAIL`;

export const FETCH_BRASPAG_AUTHORIZATION = 'FETCH_BRASPAG_AUTHORIZATION';
export const FETCH_BRASPAG_AUTHORIZATION_SUCCESS = `${FETCH_BRASPAG_AUTHORIZATION}_SUCCESS`;
export const FETCH_BRASPAG_AUTHORIZATION_FAIL = `${FETCH_BRASPAG_AUTHORIZATION}_FAIL`;



const PaymentConfigReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_POINTS_CASH_CONFIG:
      return { ...state, isLoading: true, requestMake: true, finishRequests: false, isError: false };
    case FETCH_POINTS_CASH_CONFIG_SUCCESS:
      const paymentConfig = action.payload.data;
      if (paymentConfig.error) {
        paymentConfig.errors = paymentConfig.error;
      }
      return { ...state, isLoading: false,  paymentConfig, finishRequests: true, isError: false };
    case FETCH_POINTS_CASH_CONFIG_FAIL:
      return { ...state, isLoading: false, isError: true, error: action.error, finishRequests: true };
    default:
    return { ...state };
  }
};
export default PaymentConfigReducer;

const initialStateInstallments = { isLoading: true, paymentInstallments: [], requestMake: false, finishRequests: false, isError: false };
export const PaymentInstallmentsReducer = (state = initialStateInstallments, action = {}) => {
  switch (action.type) {
    case FETCH_POINTS_CASH_INSTALLMENTS:
      return { ...state, isLoading: true, requestMake: true, finishRequests: false, isError: false };
    case FETCH_POINTS_CASH_INSTALLMENTS_SUCCESS:
      return { ...state, isLoading: false, paymentInstallments: action.payload.data, finishRequests: true, isError: false };
    case FETCH_POINTS_CASH_INSTALLMENTS_FAIL:
      return { ...state, isLoading: false, error: action.error, finishRequests: true, isError: true };
      default:
      return { ...state };
  }
};

const initialCreatePurchase = {
  isLoading: false,
  createPurchase: [],
  requestMake: false,
  finishRequests: false,
  isError: false,
  status: ''
};
export const CreatePurchaseReducer = (state = initialCreatePurchase, action = {}) => {
  switch (action.type) {
    case FETCH_CREATE_PURCHASE:
      return {
        ...state,
        isLoading: true,
        requestMake: true,
        finishRequests: false,
        isError: false
      };
    case FETCH_CREATE_PURCHASE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        createPurchase: action.payload.data,
        finishRequests: true,
        isError: false,
        status: action.payload?.data?.status || action.payload.status,
      };
    case FETCH_CREATE_PURCHASE_FAIL:

      return {
        ...state,
        isLoading: false,
        error: { message: action.error },
        finishRequests: true,
        isError: true,
        status: action?.payload?.data?.status || action.error.status
      };
    case FETCH_RESET_PURCHASE:
      return { ...state, finishRequests: false, isError: false, status: '' };
    default:
      return { ...state };
  }
};


const initialAuthorizationBraspag = { isLoading: true, authorizationBraspag: [], requestMake: false, finishRequests: false, isError: false };
export const AuthorizationBraspagReducer = (state = initialAuthorizationBraspag, action = {}) => {
  switch (action.type) {
    case FETCH_BRASPAG_AUTHORIZATION:
      return { ...state, isLoading: true, requestMake: true, finishRequests: false, isError: false };
    case FETCH_BRASPAG_AUTHORIZATION_SUCCESS:
      return { ...state, isLoading: false, authorizationBraspag: action.payload.data, finishRequests: true, isError: false };
    case FETCH_BRASPAG_AUTHORIZATION_FAIL:
      return { ...state, isLoading: false, error: action.error, finishRequests: true, isError: true };
    default:
      return { ...state };
  }
};

